import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=e7d4d4bc&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=e7d4d4bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d4d4bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7d4d4bc')) {
      api.createRecord('e7d4d4bc', component.options)
    } else {
      api.reload('e7d4d4bc', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=e7d4d4bc&scoped=true&", function () {
      api.rerender('e7d4d4bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2aRjd10qCqZTs/JS/comp/GuestBox.vue"
export default component.exports